import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dropdownData: [],
  selectedUser:{
    name: "",
    providerName: "",
    service: "",
    buss_desc: "",
    entityid: "",
    entitytype:"",
    organizationid:"",
    organization_type:"",
    agsa_icon_media_url:""
  },
  agsaOrgId: "",
  pspOrgId: "",
  agOrgId: "",
  agsaEntityType:"",
  agEntityType:"",
  pspEntityType:"",
};

const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setDrodownData(state, action) {
      state.dropdownData = action.payload;
    },
    setAgsaOrgId(state, action) {
      state.agsaOrgId = action.payload;
    },
    setPspOrgId(state, action) {
      state.pspOrgId = action.payload;
    },
    setAgOrgId(state, action) {
      state.agOrgId = action.payload;
    },
    setAgsaEntityType(state, action) {
      state.agsaEntityType = action.payload;
    },
    setPspEntityType(state, action) {
      state.pspEntityType = action.payload;
    },
    setAgEntityType(state, action) {
      state.agEntityType = action.payload;
    },
    setSelectedUser(state, action) {
      state.selectedUser = action.payload;
    },

  },
});

export const { setDrodownData, setAgsaOrgId, setPspOrgId, setAgOrgId, setAgsaEntityType, setPspEntityType, setAgEntityType, setSelectedUser } = headerSlice.actions;

export default headerSlice.reducer;
